module.exports = __webpack_public_path__ + "img/small-airplane.53bdc885.png";